import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';
import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';

type SelectProps<Fields extends FieldValues> = {
  name: Path<Fields>;
  value?: string | number;
  required?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  inputSize?: string;
  options?: Array<string | number>;
  complexOptions?: Array<{
    value: string | number;
    text: string | number;
  }>;
  register?: UseFormRegister<Fields>;
  defaultValue?: string | number;
  changeFunction?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const Input = styled(BasicInputStyles)`
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="35" viewBox="0 -960 960 960" width="35"><path d="M480-357q-6 0-11-2t-10-7L261-564q-8-8-7.5-21.5T262-607q10-10 21.5-8.5T304-606l176 176 176-176q8-8 21.5-9t21.5 9q10 8 8.5 21t-9.5 22L501-366q-5 5-10 7t-11 2Z"/></svg>');
  background-repeat: no-repeat;
  background-position-x: 99%;
  background-position-x: calc(100% - 0.1875rem);
  background-position-y: 0.25rem;
  padding-right: 2rem;

  &:disabled {
    background-image: none;
  }
`;
const Select = <Fields extends FieldValues>({
  value,
  required,
  disabled,
  errorMessage,
  inputSize = 'md',
  options,
  complexOptions,
  name,
  register,
  defaultValue = '',
  changeFunction
}: SelectProps<Fields>) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const registerFunc = register ? register : () => {};
  return (
    <Input
      {...registerFunc(name)}
      required={required}
      disabled={disabled}
      inputSize={inputSize}
      errorMessage={errorMessage}
      as="select"
      value={value}
      defaultValue={defaultValue}
      onChange={changeFunction}
    >
      <option value="" disabled={required}></option>
      {options &&
        options.map((option, index) => (
          <option key={`${name}${index}`} value={option}>
            {option}
          </option>
        ))}

      {complexOptions &&
        complexOptions.map(({ value, text }, index) => (
          <option key={`${value}${index}`} value={value}>
            {text}
          </option>
        ))}
    </Input>
  );
};

export { Select };
